import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.modelValue)
    ? (_openBlock(), _createBlock(_component_Modal, _mergeProps({ key: 0 }, _ctx.successProcessBookingModalEntities), null, 16))
    : _createCommentVNode("", true)
}